import { useState, useEffect } from 'react';
import { getTechniques } from '@services/repService';

/** All techniques for the ai-prompting skill — id, key, name, phase.
 * Drives the skill radar (see PromptLanding.jsx) grouped by phase,
 * replacing the old hardcoded 6-category RADAR_AXES/LESSON_SKILL_MAP. */
export const useTechniques = () => {
  const [techniques, setTechniques] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    getTechniques()
      .then(data => { if (!cancelled) setTechniques(data); })
      .catch(() => { if (!cancelled) setTechniques([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return { techniques, loading };
};

export default useTechniques;
